'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _snapsvgCjs = require('snapsvg-cjs');

var _snapsvgCjs2 = _interopRequireDefault(_snapsvgCjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FontAwesomeIconClass = function (_Component) {
  _inherits(FontAwesomeIconClass, _Component);

  function FontAwesomeIconClass() {
    _classCallCheck(this, FontAwesomeIconClass);

    return _possibleConstructorReturn(this, (FontAwesomeIconClass.__proto__ || Object.getPrototypeOf(FontAwesomeIconClass)).apply(this, arguments));
  }

  _createClass(FontAwesomeIconClass, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, this.props);
    }
  }]);

  return FontAwesomeIconClass;
}(_react.Component);

var svgNS = 'http://www.w3.org/2000/svg';
var pathToSVG = function pathToSVG(path) {
  var p = document.createElementNS(svgNS, 'path');
  p.setAttribute('d', path);
  return p;
};

// Return true if path2 is contained (or intersect) path1
var pathContain = function pathContain(path1, path2) {
  var p2 = pathToSVG(path2);
  var length = p2.getTotalLength();
  for (var i = 0.5; i < 10; i += 1) {
    var p = p2.getPointAtLength(i / 10 * length);
    if (_snapsvgCjs2.default.path.isPointInside(path1, p.x, p.y)) {
      return true;
    }
  }
  return false;
};

var coordsToPoint = function coordsToPoint(coords) {
  var parts = coords.split(/(?=[ -])/g);
  if (parts.length === 3) {
    return [parseFloat(parts[0] + parts[1]), parseFloat(parts[2])];
  } else if (parts.length === 2) {
    return parts.map(parseFloat);
  } else if (parts.length === 1) {
    var subParts = coords.split(/(?=[.])/g);
    if (subParts.length === 3) {
      return [parseFloat(subParts[0] + subParts[1]), parseFloat(subParts[2])];
    } else {
      throw '@ntag/react-fontawesome: wrong number of subparts', coords;
    }
  } else {
    throw '@ntag/react-fontawesome: wrong number of parts', coords;
  }
};

var simplifyPosition = function simplifyPosition(position) {
  // Keep the last M part
  var parts = position.split(/M/g);
  position = parts[parts.length - 1];
  if (/m/.test(position)) {
    // Now we have only one M, and then multiple m
    var mparts = position.split(/m/g);
    var point = coordsToPoint(mparts[0]);
    for (var i = 1; i < mparts.length; i += 1) {
      var p = coordsToPoint(mparts[i]);
      point[0] += p[0];
      point[1] += p[1];
    }
    position = point[0] + ' ' + point[1];
  }

  return 'M' + position;
};
var simplifyPath = function simplifyPath(path) {
  var _path$split = path.split(/(?=[a-ln-z])/i),
      _path$split2 = _toArray(_path$split),
      position = _path$split2[0],
      rest = _path$split2.slice(1);

  return simplifyPosition(position) + rest.join('');
};
var pathDirection = function pathDirection(path) {
  var angle = 0;
  var p = pathToSVG(path);
  var length = p.getTotalLength();
  for (var i = 1; i < 49; i += 1) {
    var A = p.getPointAtLength(i * length / 50);
    var B = p.getPointAtLength((i + 1) * length / 50);
    var C = p.getPointAtLength((i + 2) * length / 50);
    var ab = Math.sqrt(Math.pow(B.y - A.y, 2) + Math.pow(B.x - A.x, 2));
    var bc = Math.sqrt(Math.pow(B.y - C.y, 2) + Math.pow(B.x - C.x, 2));
    var abc = (B.x - A.x) * (C.y - B.y) - (B.y - A.y) * (C.x - B.x);
    angle += Math.asin(abc / (ab * bc));
  }
  return angle >= 0;
};

var splitPath = function splitPath(d) {
  d = d.replace(/v([-0-9.]+)/g, 'l0 $1');
  d = d.replace(/h([-0-9.]+)/g, 'l$1 0');

  var positionFromPath = function positionFromPath(path) {
    return path.split(/[a-ln-z]/i)[0];
  };

  var newParts = [];
  var parts = d.split(/(?=m)/ig);
  var currentPart = void 0,
      currentDirection = void 0;
  var currentParts = {
    negative: []
  };
  var position = '';

  var _loop = function _loop(part) {
    var completePart = simplifyPath(position + part);
    var completeDirection = pathDirection(completePart);

    if (!currentPart) {
      currentPart = part;
      currentParts.positive = currentPart;
      currentDirection = completeDirection;
    } else if (currentParts.negative.length === 0 && completeDirection !== currentDirection && pathContain(completePart, currentParts.positive)) {
      currentParts.negative.push(currentParts.positive);
      currentParts.positive = completePart;
      currentDirection = completeDirection;
      currentPart += part;
    } else if (completeDirection !== currentDirection && (pathContain(currentParts.positive, completePart) || pathContain(completePart, currentParts.positive)) && !currentParts.negative.find(function (p) {
      return pathContain(p, completePart) || pathContain(completePart, p);
    })) {
      currentParts.negative.push(completePart);
      currentPart += part;
    } else {
      newParts.push(currentPart);
      currentPart = completePart;
      currentParts.positive = currentPart;
      currentParts.negative = [];
      currentDirection = completeDirection;
    }

    position = simplifyPosition(position + positionFromPath(part));
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var part = _step.value;

      _loop(part);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  newParts.push(currentPart);

  return newParts;
};

var FontAwesomeIconColored = function (_Component2) {
  _inherits(FontAwesomeIconColored, _Component2);

  function FontAwesomeIconColored(props) {
    _classCallCheck(this, FontAwesomeIconColored);

    var _this2 = _possibleConstructorReturn(this, (FontAwesomeIconColored.__proto__ || Object.getPrototypeOf(FontAwesomeIconColored)).call(this, props));

    _this2.iconElement = _react2.default.createRef();
    return _this2;
  }

  _createClass(FontAwesomeIconColored, [{
    key: 'color',
    value: function color(i) {
      if (this.props['fill' + i]) {
        return this.props['fill' + i];
      } else if (this.props.fill && this.props.fill.length > i) {
        return this.props.fill[i];
      } else {
        return 'currentColor';
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _this3 = this;

      var node = _reactDom2.default.findDOMNode(this.iconElement.current);
      node.childNodes.forEach(function (child, i) {
        child.setAttribute('fill', _this3.color(i));
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this4 = this;

      // If no key starts with fill, do nothing
      if (!Object.keys(this.props).find(function (key) {
        return key.startsWith('fill');
      })) {
        return;
      }

      var node = _reactDom2.default.findDOMNode(this.iconElement.current);
      var d = node.firstElementChild.getAttribute('d');
      var parts = splitPath(d);
      node.removeChild(node.firstElementChild);
      parts.forEach(function (part, i) {
        var path = document.createElementNS(svgNS, 'path');
        path.setAttribute('d', part);
        path.setAttribute('fill', _this4.color(i));
        node.appendChild(path);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(FontAwesomeIconClass, _extends({ ref: this.iconElement }, this.props));
    }
  }]);

  return FontAwesomeIconColored;
}(_react.Component);

exports.default = FontAwesomeIconColored;